import { useObserver } from "mobx-react";
import React, { useRef, useState } from "react";
import { useStores } from "../../store";
import phonePayIcon from "../../assests/svg/phonepay.svg";
import { apiPostPut } from "../../api/api_methods";
import {
  checkPromoCode,
  buyFeatures,
} from "../../api/recruiterSubscriptionsApi";
import Loader from "../reusble_components/loader";
import { AiFillCloseCircle } from "react-icons/ai";
export const GetCreditsNewPopup = ({
  gateWay = "phonePe",
  onClose,
  type = "popUP",
}) => {
  const [interviews, setInterviews] = useState(1);
  const coderef = useRef(null);
  const [coderefText, setCoderefText] = useState("");

  const handlePurchase = () => {
    console.log(`Purchasing ${interviews} interviews`);
    // Add your purchase logic here
  };
  const rangeRef = useRef(null);
  const [value, setValue] = useState(1);
  const [tax, setTax] = useState(32.22);
  const [isCouponThere, setIsCouponThere] = useState(null);
  const [couponValue, setCouponValue] = useState(0);
  const [minPrice, setMinPrice] = useState(1);
  const [maxPrice, setMaxPrice] = useState(20);
  const [interviewPrice, setInterviewPrice] = useState(179);
  const { UserStore, PopupStore } = useStores();
  const [codeMsg, setCodeMsg] = useState("");
  const [isCodeApplied, setIsCodeApplied] = useState(false);
  const [total, setTotal] = useState(211.22);
  const [showGateWay, setShowGateWay] = useState(false);
  const [gateWayDetails, setGateWayDetails] = useState({}); // to store the payment gateway details
  const [paymentUrl, setpaymentUrl] = useState(null);
  const [loader, setLoader] = useState(false);
  const redeemCode = async (e) => {
    e.preventDefault();
    console.log("adding loader");
    setLoader(true);
    // setLoading(true);
    console.log(coderef.current.value);
    const coupon = coderef.current.value;
    let company_id;

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      company_id = user?._id;
      console.log(company_id);
    } catch (error) {
      console.log("error occurred getting id", error);
    }

    const id = UserStore?.userDetails?._id ?? company_id;

    const resp = await checkPromoCode(coupon, value * interviewPrice);
    coderef.current.value = "";

    console.log("setting loader to false");
    setLoader(false);
    setCodeMsg(resp?.body?.message);
    if (resp?.status == 200) {
      setIsCodeApplied(true);
      coderef.current.value = coupon;
      setCouponValue(
        resp?.body?.data?.data?.credits
          ? resp?.body?.data?.data?.credits
          : resp?.body?.data?.data?.discount,
      );
    }
    setLoader(false);
  };

  const onSubmitForm = async (e) => {
    setLoader(true);

    let redirectUrl = window.location.href;
    localStorage.setItem("redirectUrl", redirectUrl);

    const features = [{ name: "AI Interviewer", count: value }];

    const response = await buyFeatures(features);
    console.log(response);

    if (response?.status === 200) {
      const url =
        response?.body?.data?.checkoutPageUrl ??
        response?.body?.data?.paymentLink;
      if (url) {
        window.open(url, "_self");
      }
    } else {
      alert(response?.body?.message || "Failed to create order");
    }
    setLoader(false);
  };
  return useObserver(() => (
    <>
      {type === "screen" ? (
        <div className=" w-full pt-10 text-black bg-white flex md:flex-row justify-between flex-col h-auto !cursor-default">
          <Loader loader={loader} text="Loading..." />
          <div className="md:w-[49%] h-fit bg-[#f5f5f5] rounded-lg flex flex-col items-start justify-start  p-8 mt-5">
            <h1 className="mb-4 text-lg text-start text-[#808080] gil-med">
              Select No. of Interviews
            </h1>
            <div className="mb-4 relative w-full">
              <div className="flex justify-between text-black text-base w-full">
                <span id="minPrice">0{minPrice}</span>
                <span id="maxPrice">{maxPrice}</span>
              </div>
              <div className="relative w-full">
                <input
                  type="range"
                  ref={rangeRef}
                  className="w-full !accent-orange-600 bg-gray-200 cursor-pointer input-type-range "
                  min={minPrice}
                  max={maxPrice}
                  defaultValue={value}
                  onChange={(e) => {
                    setValue(Number(e.target.value));
                    const percentage =
                      ((e.target.value - minPrice) / (maxPrice - minPrice)) *
                      100;
                    rangeRef.current.style.background = `linear-gradient(to right, #ff6b00 0%, #ff6b00 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`;
                  }}
                />
                <div
                  className="absolute bottom-[-30px] w-8 text-center bg-[#fae6d6] text-primary text-sm py-1 rounded transform -translate-x-1/2"
                  style={{ left: `calc(${(value / maxPrice) * 100}%  )` }}
                >
                  <p
                    className="w-0 left-1.5 rotate-180 -top-1 h-0 absolute
      border-l-[10px] border-l-transparent
      border-t-[10px] border-t-[#fae6d6]
      border-r-[10px] border-r-transparent"
                  ></p>
                  {value}
                </div>
              </div>
            </div>
            <div className="mt-10 flex text-[#808080] justify-between items-center w-full">
              <p>
                {value} Interviews X ₹ {interviewPrice}
              </p>
              <p>₹ {(value * interviewPrice).toFixed(2)}</p>
            </div>
          </div>
          <div
            // onClick={(e) => e.stopPropagation()}
            className="bg-white relative h-fit text-start rounded-2xl mb-4 flex flex-col p-8 py-0  w-[49%] transition-all ease-in-out duration-300 overflow-hidden"
            // style={{ transition: "height 0.3s ease-in-out" }}
          >
            {/* <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer top-4 right-4"
              onClick={onClose}
            /> */}
            {/* <h1 className="text-2xl my-3 font-bold ">Purchase</h1> */}
            {/* <p className="text-base font-medium mt-5">
              Select No. of Interviews
            </p> */}
            <div className="flex gap-3 mt-5 text-base accent-primary items-center">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setIsCouponThere(true);
                  } else {
                    setIsCouponThere(false);
                  }
                }}
                className="w-4 h-4"
              />
              <label htmlFor="coupon">Have a Coupon Code </label>
            </div>
            {isCouponThere && (
              <div className="flex justify-between items-center mt-4">
                <form
                  onSubmit={redeemCode}
                  className="bg-gray-200 py-2 rounded-lg px-3 w-full flex items-center justify-between "
                >
                  <input
                    type="text"
                    required
                    ref={coderef}
                    onChange={(e) => setCoderefText(e.target.value)}
                    className="bg-transparent w-[70%] outline-none"
                  />
                  {!isCodeApplied ? (
                    <button
                      type="submit"
                      className={`text-base ${
                        coderefText.length < 8
                          ? "text-gray-500 cursor-not-allowed"
                          : "text-primary cursor-pointer"
                      }`}
                    >
                      Apply
                    </button>
                  ) : (
                    <p className="text-green-500"> Applied</p>
                  )}
                </form>
              </div>
            )}
            {!isCodeApplied ? (
              <p className="text-xs w-fit ml-2 mt-2 text-red-500">{codeMsg}</p>
            ) : (
              <p className="text-xs w-fit ml-2 mt-2 text-green-500">
                {codeMsg}
              </p>
            )}
            <div className="text-base border-b-2 text-gray-500 font-medium border-gray-200 border-dashed pb-5">
              <div className="flex justify-between items-center mt-4">
                <p>Purchasing Value</p>
                <p className="w-24 flex justify-between items-center">
                  <p>₹</p> {(value * interviewPrice).toFixed(2)}{" "}
                </p>
              </div>
              {isCodeApplied && couponValue && (
                <div className="flex justify-between items-center mt-4">
                  <p>Discount </p>
                  <p
                    className={` ${
                      Number(couponValue) > 0 ? "text-green-500" : null
                    } w-24 flex justify-between items-center`}
                  >
                    <p>₹</p> - {couponValue?.toFixed(2)}{" "}
                  </p>
                </div>
              )}
              <div className="flex justify-between items-center mt-4">
                <p>TAX (18%)</p>
                <p className=" w-24 flex justify-between items-center">
                  <p>₹</p> +{" "}
                  {(
                    (Number(value) * Number(interviewPrice) -
                      Number(couponValue)) *
                    0.18
                  ).toFixed(2)}{" "}
                </p>
              </div>
            </div>
            <div className="flex justify-between text-lg items-center mt-4">
              <p className="flex items-center text-lg gap-3 whitespace-nowrap">
                Total Purchasing Value{" "}
                <img src={phonePayIcon} className="h-6 w-6" alt="" />
              </p>
              <button
                onClick={() => {
                  if (
                    (Number(value) * Number(interviewPrice) - couponValue) *
                      0.18 +
                      Number(value) * Number(interviewPrice) -
                      couponValue <
                    0
                  ) {
                    return;
                  } else {
                    onSubmitForm();
                  }
                }}
                className={`px-4 py-2 flex justify-center items-center whitespace-nowrap text-sm text-white rounded-xl ${
                  (Number(value) * Number(interviewPrice) - couponValue) *
                    0.18 +
                    Number(value) * Number(interviewPrice) -
                    couponValue <
                  0
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-primary"
                }`}
              >
                Pay
                <span className="text-xl ml-2">
                  ₹{" "}
                  {(
                    (Number(value) * Number(interviewPrice) - couponValue) *
                      0.18 +
                    Number(value) * Number(interviewPrice) -
                    couponValue
                  ).toFixed(2)}
                </span>
              </button>
            </div>
            {(Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
              Number(value) * Number(interviewPrice) -
              couponValue <
              0 && (
              <p className="text-red-500 ml-auto text-sm">
                The coupon will not be applied
              </p>
            )}
          </div>
        </div>
      ) : (
        <div
          onClick={onClose}
          className="fixed  top-0 left-0 w-full h-full text-black bg-black backdrop-blur-sm bg-opacity-50 flex items-center justify-center !cursor-default"
        >
          <Loader loader={loader} text="Loading..." />
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white relative  h-fit text-start rounded-2xl mb-4 flex flex-col md:w-[45vw] md:px-14 lg:px-14 px-5 p-10 lg:w-[45vw] w-[95vw] transition-all ease-in-out duration-300 overflow-hidden"
            style={{ transition: "height 0.3s ease-in-out" }}
            nb
          >
            <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer top-4 right-4"
              onClick={onClose}
            />
            <h1 className="text-2xl my-3 font-bold ">Purchase</h1>
            <p className="text-base font-medium mt-5">
              Select No. Of Interviews
            </p>
            {/* <input type="range" name="" className='w-[40vw]  [&::-webkit-slider-runnable-track]:rounded-full accent-primary [&::-webkit-slider-runnable-track]:bg-grey-100/ [&::--moz-range-track]:bg-gray-100' id="" /> */}

            <div className="mb-4 relative">
              <div className="flex justify-between text-gray-500 text-base w-full">
                <span id="minPrice">0{minPrice}</span>
                <span id="maxPrice">{maxPrice}</span>
              </div>
              <div className="relative w-full">
                <input
                  type="range"
                  ref={rangeRef}
                  className="w-full !accent-orange-600 bg-gray-200 cursor-pointer input-type-range "
                  min={minPrice}
                  max={maxPrice}
                  defaultValue={value}
                  onChange={(e) => {
                    setValue(Number(e.target.value));

                    console.log(
                      "value",
                      value,
                      "interviewPrice",
                      interviewPrice,
                      "couponValue",
                      couponValue,
                    );

                    // set the color to the linear greadient according to the value in %
                    const percentage =
                      ((e.target.value - minPrice) / (maxPrice - minPrice)) *
                      100;
                    rangeRef.current.style.background = `linear-gradient(to right, #ff6b00 0%, #ff6b00 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`;

                    // setTotal(Number((value * interviewPrice)) + Number((tax).toFixed(2)) - Number(couponValue));
                  }}
                />
                <div
                  className="absolute bottom-[-30px] w-8 text-center bg-[#fae6d6] text-primary   text-sm py-1 rounded transform -translate-x-1/2"
                  style={{ left: `calc(${(value / maxPrice) * 100}%  )` }}
                >
                  <p
                    className="w-0 left-1.5 rotate-180 -top-1 h-0 absolute
border-l-[10px] border-l-transparent
border-t-[10px] border-t-[#fae6d6]
border-r-[10px] border-r-transparent"
                  ></p>
                  {value}
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-5 text-base accent-primary items-center">
              <input
                type="checkbox"
                onChange={(e) => {
                  console.log(e.target.checked); // Logs true when checked, false when unchecked
                  if (e.target.checked) {
                    setIsCouponThere(true);
                  } else {
                    setIsCouponThere(false);
                  }
                }}
              />

              <label htmlFor="coupon">Have a Coupon Code </label>
            </div>
            {isCouponThere && (
              <div className="flex justify-between items-center mt-4">
                <form
                  onSubmit={redeemCode}
                  className="bg-gray-200 py-2 rounded-lg px-3 w-3/5 flex items-center justify-between "
                >
                  <input
                    type="text"
                    required
                    ref={coderef}
                    onChange={(e) => setCoderefText(e.target.value)}
                    className="bg-transparent w-[70%] outline-none"
                  />
                  {!isCodeApplied ? (
                    <button
                      type="submit"
                      className={`text-base  ${
                        coderefText.length < 8
                          ? "text-gray-500 cursor-not-allowed"
                          : "text-primary cursor-pointer"
                      }`}
                    >
                      Apply
                    </button>
                  ) : (
                    <p className="text-green-500"> Applied</p>
                  )}
                </form>
              </div>
            )}
            {!isCodeApplied ? (
              <p className="text-xs w-fit ml-2 mt-2 text-red-500">{codeMsg}</p>
            ) : (
              <p className="text-xs w-fit ml-2 mt-2 text-green-500">
                {codeMsg}
              </p>
            )}
            <div className="text-base border-b-2 text-gray-500 font-medium border-gray-200 border-dashed pb-5">
              <div className="flex justify-between items-center mt-4">
                <p>Purchasing Value</p>
                <p className="w-20 flex justify-between items-center">
                  <p>₹</p> {(value * interviewPrice).toFixed(2)}{" "}
                </p>
              </div>
              {isCodeApplied && couponValue && (
                <div className="flex justify-between items-center mt-4">
                  <p>Discount </p>
                  <p
                    className={` ${
                      Number(couponValue) > 0 ? "text-green-500" : null
                    } w-20 flex justify-between items-center`}
                  >
                    <p>₹</p> - {couponValue?.toFixed(2)}{" "}
                  </p>
                </div>
              )}
              <div className="flex justify-between items-center mt-4">
                <p>TAX (18%)</p>
                <p className=" w-20 flex justify-between items-center">
                  <p>₹</p> +{" "}
                  {(
                    (Number(value) * Number(interviewPrice) -
                      Number(couponValue)) *
                    0.18
                  ).toFixed(2)}{" "}
                </p>
              </div>
            </div>
            <div className="flex justify-between text-lg items-center mt-4">
              <p className="flex items-center text-base gap-3 whitespace-nowrap">
                Total Purchasing Value{" "}
                <img src={phonePayIcon} className="h-5 w-5" alt="" />
              </p>
              <button
                onClick={() => {
                  if (
                    (Number(value) * Number(interviewPrice) - couponValue) *
                      0.18 +
                      Number(value) * Number(interviewPrice) -
                      couponValue <
                    0
                  ) {
                    return;
                  } else {
                    onSubmitForm();
                  }
                }}
                className={`px-4 py-2 whitespace-nowrap text-sm text-white rounded-xl ${
                  (Number(value) * Number(interviewPrice) - couponValue) *
                    0.18 +
                    Number(value) * Number(interviewPrice) -
                    couponValue <
                  0
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-primary"
                }`}
              >
                Pay ₹
                {(
                  (Number(value) * Number(interviewPrice) - couponValue) *
                    0.18 +
                  Number(value) * Number(interviewPrice) -
                  couponValue
                ).toFixed(2)}
              </button>
            </div>
            {(Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
              Number(value) * Number(interviewPrice) -
              couponValue <
              0 && (
              <p className="text-red-500 ml-auto text-sm">
                The coupon will not be applied
              </p>
            )}
          </div>
        </div>
      )}
    </>
  ));
};

export default GetCreditsNewPopup;
